/**
 * Investors API
 * Domain API via HTTP transport (apiTransport) to the backend /api RPC.
 */

import { InvestmentEntity, InvestmentEntityInvestor, VendorPortfolioItem, Investor } from '@repo/shared-types';
import { apiTransport as router } from './transport';
import { getContext } from './core';

export const investorsApi = {
  investors: {
    list: async () => router.get<Investor[]>('/investors'),
    get: async (id: string) => router.get<Investor>(`/investors/${id}`)
  },
  investmentEntities: {
    list: async () => router.get<InvestmentEntity[]>('/investment-entities'),
    get: async (id: string) => router.get<InvestmentEntity>(`/investment-entities/${id}`),
    create: async (entity: InvestmentEntity) => {
      const context = getContext();
      return router.post<InvestmentEntity>('/investment-entities', entity, context);
    },
    update: async (id: string, updates: Partial<InvestmentEntity>) => {
      const context = getContext();
      return router.patch<InvestmentEntity>(`/investment-entities/${id}`, updates, context);
    },
    delete: async (id: string) => {
      const context = getContext();
      return router.delete<{ success: boolean }>(`/investment-entities/${id}`, context);
    }
  },
  entityInvestors: {
    list: async (entityId?: string, investorId?: string) => {
      let query = '';
      if (entityId) query = `?entityId=${entityId}`;
      if (investorId) query = (query ? `${query}&` : '?') + `investorId=${investorId}`;
      return router.get<InvestmentEntityInvestor[]>(`/entity-investors${query}`);
    },
    create: async (relationship: InvestmentEntityInvestor) => {
      const context = getContext();
      return router.post<InvestmentEntityInvestor>('/entity-investors', relationship, context);
    },
    get: async (id: string) => router.get<InvestmentEntityInvestor>(`/entity-investors/${id}`),
    update: async (id: string, updates: Partial<InvestmentEntityInvestor>) => {
      const context = getContext();
      return router.patch<InvestmentEntityInvestor>(`/entity-investors/${id}`, updates, context);
    },
    delete: async (id: string) => {
      const context = getContext();
      return router.delete<{ success: boolean }>(`/entity-investors/${id}`, context);
    }
  },
  portfolioItems: {
    list: async (vendorId: string) => router.get<VendorPortfolioItem[]>(`/portfolio-items?vendorId=${vendorId}`),
    create: async (item: VendorPortfolioItem) => {
      const context = getContext();
      return router.post<VendorPortfolioItem>('/portfolio-items', item, context);
    },
    update: async (id: string, updates: Partial<VendorPortfolioItem>) => {
      const context = getContext();
      return router.patch<VendorPortfolioItem>(`/portfolio-items/${id}`, updates, context);
    },
    delete: async (id: string) => {
      const context = getContext();
      return router.delete<{ success: boolean }>(`/portfolio-items/${id}`, context);
    }
  }
};

